export default "__VITE_ASSET__D7_s0FWV__"